var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12.5,
    viewBox: "0 0 15 12.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Share_-_Default",
    "data-name": "Share - Default",
    d: "M19.5,12.687,13.25,6.75v3.333c-5.833.833-7.917,5-8.75,9.167C6.583,16.333,9.083,15,13.25,15v3.417Z",
    transform: "translate(-4.5 -6.75)",
    fill: "#b9b9b9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDefault);
export default __webpack_public_path__ + "static/media/Share - Default.2115e2c7d72bfd5524d8207313b74afa.svg";
export { ForwardRef as ReactComponent };